module.exports = __webpack_public_path__ + "static/homepage-hero-image-ec7ab89079f52ff0fc16e06201c0c6c0.png";